import React from 'react'
import { connect } from 'react-redux'

import { Container, Header } from 'semantic-ui-react'

import VersionNumber from '../components/VersionNumber'

function About({ config }) {
	
	return (
		<>
			<Container text style={{ color: '#fff', flex: 1, padding: '2em 0' }}>
				
				<Header as="h1" inverted style={{ marginbottom: '1em' }}>About Us</Header>
				
				<p>Confused by the house hunting process? Want to know what fees and taxes you'll be charged? Whether you are buying, selling, transferring or mortgaging any property in Namibia we are able to assist with all your needs.  Our firm is recognized as one of the specialist commercial conveyancing and property law firms in Namibia - with additional law services aimed at the financial sector. We carry out the necessary obligations in order to make the process smooth and legit.</p>
				<p>We can assist not only in buying and selling of your property but also with working out your budget and costs - and even the transfer and registration thereof!</p>
				<p>We are fully qualified and experienced in all aspects of Namibian Property Law and Conveyancing - including the following:</p>
				<ul>
					<li>Residential sale and purchases</li>
					<li>Rural, commercial and agricultural sales and purchases</li>
					<li>Sale and purchase of business</li>
					<li>All transfers and Registrations</li>
					<li>Mortgage Bonds Registrations</li>
					<li>Plot and Plan agreements and purchases</li>
					<li>Sectional Titles sales and transfers</li>
					<li>Effective cost structuring</li>
					<li>Loan agreements</li>
				</ul>
				<VersionNumber />
				
			</Container>
		</>
	)
}

const mapStateToProps = state => ({
	config: state.config.config
})

export default connect(
	mapStateToProps,
	null
)(About)
